/* istanbul ignore file */

export default {
  employeeId: {
    type: 'string',
    required: true,
    maxSize: 128,
  },
  relatedPeriodStart: {
    type: 'date',
    maxDate: '$NOW',
  },
  relatedPeriodEnd: {
    type: 'date',
    maxDate: '$NOW',
    minDate: '$relatedPeriodStart',
  },
  onBehalfOf: {
    type: 'string',
    required: true,
    maxSize: 128,
  },
  onBehalfOfEmployee: {
    type: 'string',
    required: {
      value: true,
      when: {
        $onBehalfOf: {
          eq: 'ANOTHER_EMPLOYEE',
        },
      },
      message: 'Please fill this field',
    },
    maxSize: 128,
  },
  externalEmployee: {
    type: 'string',
    required: {
      value: true,
      when: {
        $onBehalfOf: {
          eq: 'EXTERNAL_USER',
        },
      },
      message: 'Please fill this field',
    },
    maxSize: 128,
  },
  obtainedBy: {
    type: 'string',
    required: {
      value: true,
      when: {
        $onBehalfOf: {
          ne: 'MYSELF',
        },
      },
      message: 'Please fill this field',
    },
    maxSize: 128,
  },
  relatedProject: {
    type: 'string',
    maxSize: 128,
  },
  feedbackGrades: {
    type: 'object',
    properties: {
      GENERAL: {
        type: 'object',
        properties: {
          description: {
            type: 'string',
            required: {
              value: true,
            },
            maxSize: 10000,
          },
          attachmentsIds: {
            type: 'array',
            maxSize: 10,
          },
        },
      },
    },
  },
};
